import { FC } from 'react';

export const LogoShortWhite: FC = () => (
  <svg viewBox="0 0 112 99" fill="none">
    <path
      d="M29.7168 0.864513C36.788 0.692708 43.8587 0.404524 50.9305 0.376585C61.3351 0.335472 71.7405 0.480045 82.2329 1.10913C79.0156 7.39682 75.7111 13.1209 72.4065 18.845C61.5295 18.6907 50.6526 18.5363 39.3929 17.8066C35.9124 11.7756 32.8146 6.32006 29.7168 0.864513Z"
      fill="#FFFF"
    />
    <path
      d="M81.9514 96.3154C82.1533 97.0908 82.3552 97.8662 82.5646 98.6704C64.9843 98.6704 47.6087 98.6704 29.7148 98.6704C30.3021 97.308 30.7337 96.307 31.5825 94.7729C34.3746 89.9279 36.7493 85.616 39.124 81.304C41.6873 80.9987 44.2494 80.4476 46.8144 80.4334C55.2238 80.3866 63.6343 80.5349 72.5699 81.0894C76.0474 86.4855 78.9994 91.4005 81.9514 96.3154Z"
      fill="#FFFF"
    />
    <path
      d="M29.0592 93.1794C27.8518 98.0616 26.0453 95.4038 24.8005 93.355C21.4296 87.8071 18.2759 82.1271 15.0413 76.4965C10.2645 68.1814 5.49216 59.8637 0.222656 50.6844C7.28997 50.6844 13.3892 50.5863 19.4794 50.777C20.5455 50.8104 21.9835 51.8147 22.555 52.7814C27.469 61.0934 32.2425 69.489 36.986 77.9003C37.3324 78.5143 37.1167 79.4454 36.7938 80.7297C33.97 85.2134 31.5146 89.1964 29.0592 93.1794Z"
      fill="#FFFF"
    />
    <path
      d="M74.8965 80.0928C78.8096 72.7996 83.0873 65.6729 86.5197 58.1601C89.2359 52.2145 91.3529 49.6386 97.9995 50.675C102 50.675 107.131 50.6749 111.557 50.6749C110.917 52.2724 110.635 53.3197 110.113 54.2297C102.491 67.519 94.8642 80.8054 87.1424 94.0365C86.5107 95.1191 85.1818 95.7948 84.0618 96.0199C80.93 90.2845 77.9133 85.1886 74.8965 80.0928Z"
      fill="#FFFF"
    />
    <path
      d="M36.9401 18.2935C36.6121 19.96 36.671 21.8394 35.8912 23.2574C31.8118 30.6751 27.6757 38.0736 23.1793 45.2404C22.1937 46.8114 19.7173 48.1783 17.8312 48.3153C12.2697 48.7194 6.65989 48.4596 0 48.4596C9.40887 32.5857 18.2623 17.6489 27.5708 3.09033C30.9972 8.41022 33.9687 13.3519 36.9401 18.2935Z"
      fill="#FFFF"
    />
    <path
      d="M85.9653 2.85254C94.4398 17.6791 102.914 32.5057 111.97 48.3483C104.695 48.3483 98.201 48.3901 91.7096 48.2795C91.1033 48.2691 90.3154 47.4065 89.9457 46.7511C84.8972 37.8003 79.9075 28.8162 75.2012 19.3006C76.4977 17.0389 77.4062 15.2565 78.5134 13.6073C80.944 9.98661 83.4752 6.43334 85.9653 2.85254Z"
      fill="#FFFF"
    />
  </svg>
);

export default LogoShortWhite;
